import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class ResumoCtasPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { buscaAno } = this.props.filtros;

        if (buscaAno) {
            axios
                .get('/titulos/listaResumoCtas', {
                    params: {
                        print: true,
                        ano: buscaAno,
                        anual: 'S'
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.setState({
                        listaRegistros: data,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValorCred = (registro) => {
        if (registro.pc_tipo === 'E') {
            return (
                <span> {numeral(parseFloat(registro.tpp_valor)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderValorDeb = (registro) => {
        if (registro.pc_tipo === 'S') {
            return (
                <span> {numeral(parseFloat(registro.tpp_valor)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderHistorico = (tit_descricao, registro) => {
        return (
            <span>{'[' + registro.pes_nome + '] ' + tit_descricao}</span>
        );
    };



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Resumo Financeiro por Contas
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Ano: </span>
                                <span>{this.props.ano}</span>
                            </Col>
                        </Row>


                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.pc_codigo)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="pc_conta"
                                    dataIndex="pc_conta"
                                    title="Conta"
                                    width={100}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pc_codigo"
                                    dataIndex="pc_codigo"
                                    title="Cód."
                                    width={70}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pc_descricao"
                                    dataIndex="pc_descricao"
                                    title="Descrição da Conta"
                                    width={200}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr01"
                                    dataIndex="vlr01"
                                    title="Jan"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr02"
                                    dataIndex="vlr02"
                                    title="Fev"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr03"
                                    dataIndex="vlr03"
                                    title="Mar"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr04"
                                    dataIndex="vlr04"
                                    title="Abr"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr05"
                                    dataIndex="vlr05"
                                    title="Mai"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr06"
                                    dataIndex="vlr06"
                                    title="Jun"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr07"
                                    dataIndex="vlr07"
                                    title="Jul"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr08"
                                    dataIndex="vlr08"
                                    title="Ago"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr09"
                                    dataIndex="vlr09"
                                    title="Set"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr10"
                                    dataIndex="vlr10"
                                    title="Out"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr11"
                                    dataIndex="vlr11"
                                    title="Nov"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlr12"
                                    dataIndex="vlr12"
                                    title="Dez"
                                    render={this.renderValor}
                                    width={110}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default ResumoCtasPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/ResumoCtasPrintModal.js